import { Route } from "react-router-dom";
import MainContainerCard from "./components/main-container-card/MainContainerCard";
import MobileNavBar from "./components/mobile-header/MobileNavBar";
import MovieIndexContextProvider from "./context/MovieIndexContext";
import NavBar from "./components/nav-bar/NavBar";
import MobileSearch from "./components/mobile-search/MobileSearch";
import VideoContainer from "./components/video-container/VideoContainer";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import "./App.css";
const App = () => {
  return (
    <div className="App">
      <MovieIndexContextProvider>
        <Route path="/" exact>
          <NavBar />
          <MobileNavBar />
          <MobileSearch />
          <MainContainerCard />
        </Route>
        <Route path="/play">
          <NavBar />
          <MobileNavBar />
          <MobileSearch />
          <VideoContainer />
        </Route>
      </MovieIndexContextProvider>
    </div>
  );
};

export default App;
